module.exports = __webpack_public_path__ + "img/x.7b890cfa.svg";